import React from 'react';
import FullScreenDataContainer from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import { useNewClientContext } from 'Context/NewClientContext';
import ClientPicker from 'Components/ClientApp/ClientPicker';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const ClientContainer = () => {
  const { isInitializing } = useNewClientContext();
  const { householdResource } = useSimpleHousehold();

  return (
    <FullScreenDataContainer
      component={ClientPicker}
      loading={isInitializing || !householdResource}
    />
  );
};

export default ClientContainer;
